export default {
	"subscribe.CardClick": "卡片點擊",
	"subscribe.checkTheDetails": "查看詳情",
	"subscribe.subscribing": "訂閱中",
	"subscribe.continueToSubscribe": "繼續訂閱",
	"subscribe.Paused": "已暫停",
	"subscribe.TurnOnRenewal": "開啟續費",
	"subscribe.expired": "已失效",
	"subscribe.completed": "已完成",
	"subscribe.ViewDeductionRecords": "查看扣費記錄",
	"subscribe.UnfortunatelyNoMatchingDataWasFound": "非常遺憾，沒有找到符合條件的數據"
}